import React from 'react';
import './loader.css';

const ImageLoader = (): React.JSX.Element => {
    return <div className="image-loader"></div>
}

export default ImageLoader;